<template>
  <div>
    <GanttElastic
      :options="options"
      :tasks="tasks"
      v-if="tasks && tasks.length"
    >
      <template v-slot:header>
        <GanttElasticToolbar>
          <template v-slot:from>
            <slot name="header"></slot>
          </template>
        </GanttElasticToolbar>
      </template>
    </GanttElastic>
  </div>
</template>

<script>
import GanttElastic from 'gantt-elastic'
import GanttElasticToolbar from './toolbar.vue'
import dayjs from 'dayjs'
import Math from '@/libs/util.math.js'
import options from './options'
export default {
  name: 'order-gantt',
  components: { GanttElastic, GanttElasticToolbar },
  data() {
    return {
      tasks: [],
      options: options(),
    }
  },
  provide() {
    return { loadGantt: (formData = {}) => this.loadData(formData) }
  },
  mounted() {
    this.loadData()
    this.setHeight()
    window.addEventListener('resize', this.setHeight())
  },
  destroyed() {
    window.removeEventListener('resize', this.setHeight())
  },
  methods: {
    async loadData(formData = {}) {
      const data = await this.getData(formData)
      if (!data || !data.length) return

      this.tasks = []
      let tasksID = 1
      for (let key in data) {
        const {
          planName,
          planTotalQty,
          planFinishQty,
          planStartDate,
          planEndDate,
          planDetail = [],
        } = data[key]

        const start = new Date(dayjs(planStartDate, 'YYYY-MM-DD')).getTime()
        const end = new Date(dayjs(planEndDate, 'YYYY-MM-DD')).getTime()
        const percent =
          Math.round(Math.evaluate(`${planFinishQty}/${planTotalQty}`), 2) * 100

        const parentId = tasksID
        this.tasks.push({
          id: tasksID++,
          seq: `${parseInt(key) + 1}`,
          planName,
          planTotalQty,
          planFinishQty,
          label: planName,
          start,
          duration: end - start,
          percent,
          type: 'project',
        })

        const tasks = planDetail.map((vaule, index) => {
          const childStart = new Date(
            dayjs(vaule.planStartDate, 'YYYY-MM-DD')
          ).getTime()
          const childEnd = new Date(
            dayjs(vaule.planEndDate, 'YYYY-MM-DD')
          ).getTime()
          const childPercent =
            Math.round(
              Math.evaluate(`${vaule.planFinishQty}/${vaule.planTotalQty}`),
              2
            ) * 100
          return {
            id: tasksID++,
            seq: `${parseInt(key) + 1}.${index + 1}`,
            planName: vaule.planName,
            planTotalQty: vaule.planTotalQty,
            planFinishQty: vaule.planFinishQty,
            parentId,
            label: vaule.planName,
            start: childStart,
            duration: childEnd - childStart,
            percent: childPercent,
            type: 'milestone',
            style: {
              base: {
                fill: '#1EBC61',
                stroke: '#0EAC51',
              },
              'tree-row-bar': {
                fill: '#1EBC61',
                stroke: '#0EAC51',
              },
              'tree-row-bar-polygon': {
                stroke: '#0EAC51',
              },
            },
          }
        })
        this.tasks.push(...tasks)
      }
    },
    async getData(formData = {}) {
      const res = (await this.$api.planOrderScheduleTreeApi(formData)) || {}
      const { body = {} } = res
      return body.data || []
    },
    setHeight() {
      this.options.maxHeight = window.innerHeight - 250
    },
  },
}
</script>
